import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AuthService from "../services/auth.service";
import TopBar from "../components/TopBar";
import VaccineForm from "../components/forms/VaccineForm";

function UpdateVaccine() {
  const navigate = useNavigate();
  const { calfId, id } = useParams();

  useEffect(() => {
    if (!AuthService.getCurrentUser()) {
      navigate("/login");
    }
  }, [navigate]);

  return (
    <div>
      <TopBar link={"/vaccin/" + calfId + "/" + id}></TopBar>
      <div className="mx-3 rounded-lg bg-white px-3 dark:bg-slate-900">
        <div className="mb-3 flex flex-col">
          <span className="mt-2 text-2xl font-bold text-stone-700 dark:text-slate-100">
            Modifier un vaccin
          </span>
          <p className="mb-3 text-sm text-stone-400 dark:text-slate-300">
            Vous pouvez modifier ce vaccin ici.
          </p>
          <VaccineForm
            calfID={calfId}
            vaccineId={id}
            onDone={() => navigate("/veaux/" + calfId + "?view=vaccin")}
            onCancel={() => navigate("/vaccin/" + calfId + "/" + id)}
          />
        </div>
      </div>
    </div>
  );
}

export default UpdateVaccine;
